// extracted by mini-css-extract-plugin
export default {"BlocTypeRdv":"BlocTypeRdv_BlocTypeRdv__sPIzr","LibelleTypeRdv":"BlocTypeRdv_LibelleTypeRdv__+A8oC","Choix":"BlocTypeRdv_Choix__nJ084"};